module.exports = "<div class=\"text-viewer\">\n  <pre>\n    {{ text }}\n  </pre>\n</div>\n"